import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration - use the same config as MAC Console
const firebaseConfig = {
  apiKey: "AIzaSyCp1uKhKC8vLsXdvONj2vPl-QV3Jq8nQRY",
  authDomain: "tbp-svp-63eac.firebaseapp.com",
  projectId: "tbp-svp-63eac",
  storageBucket: "tbp-svp-63eac.appspot.com",
  messagingSenderId: "625915153805",
  appId: "1:625915153805:web:9c2b8b0a8f5c7d1e4b6c9d",
  measurementId: "G-1234567890"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Log initialization for debugging
console.log('🔥 Firebase initialized - App:', app.name);

export default app;
